import domReady from '../components/utils/domReady';
import store from './Store';
import clickWait from './directives/click-wait';
import {mask} from 'vue-the-mask';
import TextareaAutosize from 'vue-textarea-autosize';
const {Vue} = window;
const apps = {
    'user-management': () => import('./components/UserManagement.vue'),
    'user-account': () => import('./components/UserAccount.vue'),
    'notice-container': () => import('./components/NoticeContainer.vue'),
    'part-search': () => import('./components/PartSearch.vue'),
    'part-concierge': () => import('./components/PartConcierge.vue'),
    'part-items': () => import('./components/PartItems.vue'),
    'order-selector': () => import('./components/OrderSelector.vue'),
    'order-management': () => import('./components/OrderManagement.vue'),
    'order-container': () => import('./components/OrderContainer.vue'),
    'shopping-cart': () => import('./components/ShoppingCart.vue'),
    'textarea-autosize': () => import('vue-textarea-autosize'),
};

Vue.config.ignoredElements = Object.keys(apps).concat([
    'column-group',
    'message-inline',
    'basic-card',
    'text-cards',
    'section-wrap',
    'card-select',
    'comp-feature',
    'compound-input',
    'check-list',
    'radio-list',
    'view-cover',
]);

Vue.directive('mask', mask);
Vue.directive('click-wait', clickWait);
Vue.use(TextareaAutosize);

domReady.then(() => {
    Object.keys(apps).forEach(key => {
		let App = apps[key];
		[...document.querySelectorAll(`${key}-app`)].forEach(el => {
            new Vue({
                el,
                store,
                render: h => h(App,{props: [...el.attributes].reduce( (data,{nodeName,nodeValue}) => ({...data,[nodeName]: nodeValue}), {})})
            }); 
        });
    });
});